import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const PhpLesson9 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        <?php
         $x = 5;

         if($x > 10){
            echo "$x is greater than 10";
         }else{
            echo "$x is not greater than 10";
         }
        ?>

        `
      );

      const code1 = (
        'text',
        `
        <?php
         $x = 15;

         if($x > 10){
            echo "$x is greater than 10";
         }else if($x > 5){
            echo "$x is not greater than 5 but not greater than 10";
         }else{
            echo "$x is not greater than 5";
         }
        ?>

        `
      );







  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">

    <h3><strong>IF-ELSE Statements</strong></h3>
        <p>If-else statements in PHP work in the same way as they do in other programming languages.
        They allow you to execute different blocks of code depending on whether a specified condition is true or false.</p>
        <p>Here is an example of an if-else statement in PHP:</p>
        <CopyBlock
        language={"php"}
        text={code}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        <br />
        <p>In this example, the condition is <b>`$x &gt; 10`</b>. If the condition is true, the code block following the if statement will be executed.</p>

        <p>If the condition is false, the code block following the <b>`else`</b> statement will be executed.
        You can also use multiple conditions and <b>`elseif`</b> statements to create more complex decision-making structures:</p>
        <CopyBlock
        language={"php"}
        text={code1}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        <br />
        <p>In this example, there are three possible outcomes, depending on the value of <b>`$x`</b>. If <b>`$x`</b> is greater than 10, the first code block will be executed.
        If <b>`$x`</b> is greater than 5 but not greater than 10, the second code block will be executed. If <b>`$x`</b> is not greater than 5, the third code block will be executed.</p>
        </div>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson9
